// Alles wat de AI-interviewer op het scherm zet, in het Nederlands. De tekst is
// tegelijk de sleutel in de vertaling: QuestionnaireOpen stuurt deze lijst mee
// naar de vertaalronde, en het scherm zoekt hem op met `interviewerText`.
//
// Ook de meldingen van de server staan hier (gate.js, turn.js): die komen als
// Nederlandse tekst binnen. interviewerTexts.test.js leest de servercode en
// wordt rood zodra er een vaste `deny(…)`-melding of GENERIC_ERROR bijkomt die
// hier ontbreekt. Eén melding valt erbuiten: 'Deze vragenlijst is te lang…'
// uit interviewerPrompt.js draagt getallen en kan dus geen sleutel zijn; die
// blijft Nederlands.
//
// Nodig omdat de basislijst in QuestionnaireOpen alleen 'Welkom…' en 'Klik hier
// om te beginnen' kende; de rest bleef in elke taal Nederlands.

/** @type {string[]} */
const INTERVIEWER_TEXTS = [
    'Welkom, ik wil je een paar vragen stellen',
    'Klik hier om te beginnen',
    'Laden…',
    'Decca denkt na…',
    'Je kunt praten',
    'Jij',
    'De stem doet het even niet; je kunt de vragen meelezen.',
    // Browser (useTurnInterviewer)
    'Even geen verbinding met de assistent. Probeer het zo nog eens.',
    'Ik kan de microfoon niet gebruiken. Geef toestemming in je browser en probeer het opnieuw.',
    // Server (functions/aiInterviewer/gate.js)
    'Deze vragenlijst is niet gevonden.',
    'Deze vragenlijst is niet beschikbaar.',
    'De AI-interviewer staat niet aan voor dit onderzoek.',
    'Dat stuk is te lang om in één keer te verwerken.',
    'Dit gesprek heeft zijn maximale lengte bereikt.',
];

/**
 * @param {Object<string, string>|undefined} translations - Uit de TranslationContext
 * @param {string} text - Nederlandse tekst, tevens de sleutel
 * @returns {string} De vertaling, of de Nederlandse tekst zolang die er niet is
 */
const interviewerText = (translations, text) => translations?.[text] || text;

export { interviewerText };
export default INTERVIEWER_TEXTS;
